module.exports = __webpack_public_path__ + "static/media/02_Citation_MKII.a40e44f2.png";